import { alpha } from "@mui/material/styles";

/** White overlay on the empty cell — image shows through the remaining ~20%. */
export const SLIDING_EMPTY_SLOT_OPACITY = 0.8;

/** Board gutter / slide peek — solid white, matches empty-cell base. */
export const SLIDING_BOARD_GUTTER_GRAY = "#ffffff";

/** Semi-transparent white fill over the slice image in the empty cell. */
export function slidingEmptySlotBackground(theme, opacity = SLIDING_EMPTY_SLOT_OPACITY) {
    return alpha(theme.palette.common.white, opacity);
}
